// extracted by mini-css-extract-plugin
export default {"backgroundGray":"main_backgroundGray__PGcMR"};